/* global __webpack_modules__ */

/* eslint id-length: [2, {"exceptions":["a","b","x","y"]}] */
import mori from 'mori';
import { kffNumericValue } from '../util/util';
import filtersModule from '../filters/filters';
let filterSwitch = null;

if (__webpack_modules__[require.resolveWeak('angular')]) {
  filterSwitch = angular
    .injector(['ng', filtersModule])
    .get('filterSwitchFilter');
} else {
  filterSwitch = filtersModule;
}
/**
 * Output should appear like:
 * Options from ../config/linechart
 * @example:
   var graph.data = [{
     key: 'State Name - Distribution',
     state: 'State Name',
     characteristic: 'Distribution',
     values: [
       { x: [x], y: [value] },
       { x: [x], y: [value] }
     ]
   },
   {
     key: 'State Name - Distribution',
     state: 'State Name',
     characteristic: 'Distribution',
     values: []
   }];
 */
function buildGraphData(timeframes, keys, combined, selectedHeaders) {
  // Filter timeframe data by baseColumn selections
  return mori.mapcat((baseColumn) => {
    return mori.into(mori.vector(), mori.map((distribution) => {
      let sheetIndex = 0;
      const formatted = mori.first(mori.filter((header) => {
        return mori.get(header, 'characteristic') === mori.first(distribution);
      }, selectedHeaders));
      const state = mori.last(mori.last(mori.first(baseColumn)));
      return mori.hashMap(
        'key',
        `${state} - ${mori.first(distribution)}`,
        'state',
        state,
        'characteristic',
        mori.first(distribution),
        'type',
        mori.last(distribution).toLowerCase(),
        'Prefix',
        mori.get(mori.first(selectedHeaders), 'Prefix'),
        'Precision',
        mori.get(mori.first(selectedHeaders), 'Precision'),
        'tickValues',
        mori.map(
          (timeframe) => mori.first(timeframe), mori.reverse(timeframes)
        ),
        'selectedHeader',
        mori.first(selectedHeaders),
        'values',
        mori.sort((a, b) => {
          return mori.get(a, 'x') - mori.get(b, 'x');
        }, mori.into(mori.vector(), mori.mapcat(
          (timeframe) => mori.transduce(
            mori.comp(
              mori.filter(
                (row) => mori.every(
                  (selected) => mori.equals(
                    mori.last(mori.first(selected)),
                    mori.get(row, mori.first(mori.first(selected)))
                  ),
                  baseColumn
                )
              ),
              mori.map((row) => {
                const value = mori.get(row, distribution);
                // pulled from switchFilter.js
                const prefixChar =
                  typeof value === 'string' ? value.charAt(0) : '';
                const isPrefixed = ['<', '>'].indexOf(prefixChar) > -1;

                const y = (value === 0 ? '0' : false) ||
                  kffNumericValue(value) || null;
                return mori.hashMap(
                  'x', sheetIndex++,
                  'y', !y ? undefined : kffNumericValue(
                    filterSwitch(y, mori.toJs(formatted))
                  ) / (mori.toJs(formatted).type === 'percent' ? 100 : 1),
                  'formatted', `${isPrefixed ? prefixChar : ''}` +
                    filterSwitch(y, mori.toJs(formatted))
                );
              })
            ),
            mori.completing(mori.conj),
            mori.vector(),
            mori.last(timeframe)
          ),
          mori.reverse(timeframes)
        ))
      ));
    }, mori.rest(keys)));
  }, combined);
}

// passes in sheets
export default function(
  data,
  options,
  timeframes,
  combined,
  selected,
  distributions) {
  const selectedHeaders = mori.filter((header) => {
    const characteristic = mori.get(header, 'characteristic');
    const label = mori.get(header, 'label');

    return mori.some(
      (currentSelected) => (
        mori.first(currentSelected) === characteristic &&
          mori.last(currentSelected) === label
      ),
      mori.rest(selected)
    );
  }, data.immutableHeaders);

  return mori.count(distributions) ?
    buildGraphData(timeframes, selected, combined, selectedHeaders) :
    [];
}



// WEBPACK FOOTER //
// ../datacenter/app/js/services/linechartData.js